import styled from 'styled-components';
import theme from 'v3/theme';

export const MarkerContainer = styled.div`
  position: relative;
  background-color: ${({ background }) => theme.colors[background] || background};
  color: #fff;
  font-weight: bold;
  font-size: 12px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);

  &:after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 8px solid
      ${({ background }) => theme.colors[background] || background};
  }

  .marker-index {
    line-height: 1;
  }
`;